export enum SendEmail {    
    Blocked = -1,
    No = 0,
    Yes = 1,
    Required = 2
}